// extracted by mini-css-extract-plugin
export var menuItem = "w_r2 d_fZ d_bz d_bD d_bP d_bf";
export var menuItemSub = "w_r3 d_Z d_bz d_bP";
export var menuMainLink = "w_r4 d_f0 d_dB";
export var menuLink = "w_r5 d_f0 d_dB";
export var icon = "w_p9 d_bC d_bP";
export var divider = "w_r6 d_bC d_bP";
export var sublinks = "w_r7";
export var link = "w_mC";
export var Link = "w_r8 x_r8 x_r9 x_sv";